import { service } from "./service";

// these are for fetchAccessToken
import axios from "axios";
import store from "../redux/reduxStore";

import { loginSuccess } from "../redux/actions/auth/authActions";
import { loadProfile } from "../redux/actions/profile/profileActions";
import { getOrCreateDeviceId } from "../utils/storage";

export function checkEmailApi(payload) {
  return service.post(`v3/auth/check-email`, payload);
}

//login
export function signinApi(payload) {
  return service.post(`v3/auth/signin`, payload, {
    withCredentials: true,
  });
}

export function signoutApi(payload) {
  return service.post(`v3/auth/signout`, payload, {
    withCredentials: true,
  });
}

export function googleSignInApi(payload) {
  return service.post(`v3/auth/google-signin`, payload, {
    withCredentials: true,
  });
}

export function createProfileApi(payload) {
  return service.post(`v3/auth/create-profile`, payload);
}

export function verifyEmailApi(payload) {
  return service.post(`v3/auth/resend-verification-email`, payload);
}

export function signupApi(payload) {
  return service.post(`v3/auth/signup`, payload);
}

export function verifyCreateAccountTokenApi(payload) {
  return service.post(`v3/auth/verify-create-account-token`, payload);
}

export function resendVerificationEmailApi(payload) {
  return service.post(`v3/auth/resend-verification-email`, payload);
}

export function completeProfileApi(payload) {
  return service.post(`v3/auth/complete-profile`, payload);
}

export function requestPasswordResetApi(payload) {
  return service.post(`v3/auth/request-password-reset`, payload);
}

export function verifyPasswordResetTokenApi(payload) {
  return service.post(`v3/auth/verify-password-reset-token`, payload);
}
export function resetPasswordApi(payload) {
  return service.post(`v3/auth/reset-password`, payload);
}

export function requestCreatePasswordApi(payload) {
  return service.post(`v3/auth/request-create-password`, payload);
}

export function verifyCreatePasswordTokenApi(payload) {
  return service.post(`v3/auth/verify-create-password-token`, payload);
}

export function createPasswordApi(payload) {
  return service.post(`v3/auth/create-password`, payload);
}

let refreshTokenPromise = null;
const SERVER_URL_NODE = process.env.REACT_APP_SERVER_URL_NODE;

export async function fetchAccessToken() {
  if (!refreshTokenPromise) {
    refreshTokenPromise = (async () => {
      try {
        // using axios directly here because we don't want to intercept this request
        const result = await axios.post(
          `${SERVER_URL_NODE}/v3/auth/get-token`,
          {},
          {
            withCredentials: true,
            headers: {
              "Device-ID": getOrCreateDeviceId(),
            },
          }
        );

        const data = result.data?.data || {};

        const userInfo = data.userInfo;

        store.dispatch(loginSuccess(data));
        store.dispatch(loadProfile(userInfo));

        return data;
      } finally {
        refreshTokenPromise = null;
      }
    })();
  }

  return refreshTokenPromise;
}
